import React, { useState } from "react";
import { Drawer, Box, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppConfig } from "../../context/AppConfigContext";
import DrawerSection from "./DrawerSection";
import UserInfoHeader from "./UserInfoHeader";
import AccountSection from "./AccountSection";
import LogOutButton from "./LogOutButton";
import { useAuth } from "../../context/AuthContext";

const NavMenuMobile = ({ open, onClose }) => {
  const { config } = useAppConfig();
  const { user, isAuthenticated } = useAuth();
  const navConfig = config?.navigation || [];
  const [expandedGroup, setExpandedGroup] = useState(null);
  const navigate = useNavigate();

  const handleToggle = (label) => {
    setExpandedGroup((prev) => (prev === label ? null : label));
  };

  const handleItemClick = (path, isActive, isLaunched) => {
    if (isActive) {
      navigate(path);
      onClose();
    }
  };

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box
        sx={{
          width: "85vw",
          maxWidth: 320,
          px: 1,
          pt: 2,
          pb: 4,
          bgcolor: "#fff",
          borderTopRightRadius: 12,
          borderBottomRightRadius: 12,
          boxShadow: "4px 0 16px rgba(0,0,0,0.05)",
          height: "100%",
          overflowY: "auto",
        }}>
        <UserInfoHeader onClose={onClose} />

        {/* Sections */}
        {navConfig.map((section) => (
          <>
            <DrawerSection
              key={section.label}
              label={section.label}
              groups={section.groups || []}
              isServices={section.label === "Services"}
              expandedGroup={expandedGroup}
              onToggle={handleToggle}
              onItemClick={handleItemClick}
            />
            <Divider sx={{ mb: 3, mx: 1.5, borderColor: "#EFEFEF" }} />
          </>
        ))}

        {user && isAuthenticated && (
          <>
            <AccountSection onClose={onClose} />
            <LogOutButton onClose={onClose} />
          </>
        )}
      </Box>
    </Drawer>
  );
};

export default NavMenuMobile;
